import { create } from 'zustand';

interface DialogConfig {
  title?: string;
  message: string;
  type?: 'alert' | 'confirm';
  confirmText?: string;
  cancelText?: string;
  destructive?: boolean;
}

interface DialogState {
  isOpen: boolean;
  config: DialogConfig | null;
  resolvePromise: ((value: boolean) => void) | null;

  alert: (message: string, title?: string) => Promise<void>;
  confirm: (message: string, options?: Omit<DialogConfig, 'message' | 'type'>) => Promise<boolean>;
  
  close: (value: boolean) => void;
}

export const useDialogStore = create<DialogState>((set, get) => ({
  isOpen: false,
  config: null,
  resolvePromise: null,

  alert: (message, title = 'Aviso') => {
    return new Promise((resolve) => {
      set({
        isOpen: true,
        config: { type: 'alert', message, title, confirmText: 'OK' },
        resolvePromise: resolve as any,
      });
    });
  },

  confirm: (message, options = {}) => {
    return new Promise((resolve) => {
      set({
        isOpen: true,
        config: { 
          type: 'confirm', 
          message, 
          title: options.title || 'Confirmar',
          confirmText: options.confirmText || 'Confirmar',
          cancelText: options.cancelText || 'Cancelar',
          destructive: options.destructive || false
        },
        resolvePromise: resolve,
      });
    });
  },

  close: (value) => {
    const { resolvePromise } = get();
    if (resolvePromise) {
      resolvePromise(value);
    }
    set({ isOpen: false, resolvePromise: null });
  },
}));

// Export helper functions so we can import them directly without hooks
export const dialogs = {
  alert: (message: string, title?: string) => useDialogStore.getState().alert(message, title),
  confirm: (message: string, options?: Omit<DialogConfig, 'message' | 'type'>) => useDialogStore.getState().confirm(message, options)
};
